import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import ContactIcon from "./images/ic_contact.svg";
import FacebookIcon from "./images/ic_facebook.svg";
import InstagramIcon from "./images/ic_instagram.svg";
import LinkedinIcon from "./images/ic_linkedin.svg";
import RssIcon from "./images/ic_rss.svg";
import TwitterIcon from "./images/ic_twitter.svg";
var RTLSocialLinks = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSocialLinks, _LitElement);
  function RTLSocialLinks() {
    var _this;
    _classCallCheck(this, RTLSocialLinks);
    _this = _callSuper(this, RTLSocialLinks);
    _this.site = 'rtl';
    _this.type = 'large';
    if (window.rtlsites) {
      _this.site = window.rtlsites.config.site;
    }
    return _this;
  }
  _createClass(RTLSocialLinks, [{
    key: "_renderRTL",
    value: function _renderRTL() {
      return html(_t || (_t = _`
            <style>${0}</style>
            <div class="social-links-container social-links-container--${0} flavor-lu">
                <ul class="social-links__ul">
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--facebook" target="_blank" href="https://www.facebook.com/RTL.Letzebuerg/">
                        <img class="social-links__facebook" style="width: 27px; height: 27px;" src="${0}" alt="facebook"/>
                        <p class="social-links__p"> Facebook </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--twitter" target="_blank" href="https://twitter.com/RTLlu?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor">
                        <img class="social-links__twitter" style="width: 28px; height: 28px;" src="${0}" alt="twitter"/>
                        <p class="social-links__p"> Twitter </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--instagram" target="_blank" href="https://www.instagram.com/rtl.letzebuerg/">
                        <img class="social-links__instagram" style="width: 27px; height: 27px;" src="${0}" alt="instagram"/>
                        <p class="social-links__p"> Instagram </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--contact" target="_blank" href="https://www.rtl.lu/feedback">
                        <img class="social-links__contact" style="width: 27px; height: 21px;" src="${0}" alt="contact"/>
                        <p class="social-links__p"> Contact </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--rss" target="_blank" href="http://www.rtl.lu/rss/">
                            <img class="social-links__rss" style="width: 23px; height: 23px;" src="${0}" alt="rss"/>
                            <p class="social-links__p"> RSS </p>
                        </a>
                    </li>
                </ul>
            </div>
        `), css, this.type, FacebookIcon, TwitterIcon, InstagramIcon, ContactIcon, RssIcon);
    }
  }, {
    key: "_renderToday",
    value: function _renderToday() {
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="social-links-container social-links-container--${0} flavor-en">
                <ul class="social-links__ul">
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--facebook" target="_blank" href="https://www.facebook.com/rtltoday/">
                            <img class="social-links__facebook" style="width: 27px; height: 27px;" src="${0}" alt="facebook"/>
                            <p class="social-links__p"> Facebook </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--twitter" target="_blank" href="https://twitter.com/rtl_today?lang=fr">
                            <img class="social-links__twitter" style="width: 28px; height: 28px;" src="${0}" alt="twitter"/>
                            <p class="social-links__p"> Twitter </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--instagram" target="_blank" href="https://www.instagram.com/rtltoday/">
                            <img class="social-links__instagram" style="width: 27px; height: 27px;" src="${0}" alt="instagram"/>
                            <p class="social-links__p"> Instagram </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--linkedin" target="_blank" href="https://www.linkedin.com/company/rtltoday/">
                            <img class="social-links__linkedin" style="width: 27px; height: 27px;" src="${0}" alt="linkedin"/>
                            <p class="social-links__p"> Linkedin </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--contact" target="_blank" href="https://www.rtl.lu/feedback">
                            <img class="social-links__contact" style="width: 27px; height: 21px;" src="${0}" alt="contact"/>
                            <p class="social-links__p"> Contact </p>
                        </a>
                    </li>
                </ul>
            </div>
        `), css, this.type, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, ContactIcon);
    }
  }, {
    key: "_render5minutes",
    value: function _render5minutes() {
      return html(_t3 || (_t3 = _`
            <style>${0}</style>
            <div class="social-links-container social-links-container--${0} flavor-fr">
                <ul class="social-links__ul">
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--facebook" target="_blank" href="https://www.facebook.com/5minuteslux/">
                        <img class="social-links__facebook" style="width: 27px; height: 27px;" src="${0}" alt="facebook"/>
                        <p class="social-links__p"> Facebook </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--twitter" target="_blank" href="https://twitter.com/RTL5minutes?lang=fr">
                        <img class="social-links__twitter" style="width: 28px; height: 28px;" src="${0}" alt="twitter"/>
                        <p class="social-links__p"> Twitter </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--instagram" target="_blank" href="https://www.instagram.com/rtl.letzebuerg/">
                        <img class="social-links__instagram" style="width: 27px; height: 27px;" src="${0}" alt="instagram"/>
                        <p class="social-links__p"> Instagram </p>
                        </a>
                    </li>
                    <li class="social-links__li">
                        <a class="social-links__link social-links__link--contact" target="_blank" href="https://www.rtl.lu/feedback">
                        <img class="social-links__contact" style="width: 27px; height: 21px;" src="${0}" alt="contact"/>
                        <p class="social-links__p"> Contact </p>
                        </a>
                    </li>
                </ul>
            </div>
        `), css, this.type, FacebookIcon, TwitterIcon, InstagramIcon, ContactIcon);
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.site) {
        case 'rtltoday':
          return this._renderToday();
        case '5minutes':
          return this._render5minutes();
        default:
          return this._renderRTL();
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        site: {
          type: String
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLSocialLinks;
}(LitElement);
export { RTLSocialLinks as default };
window.customElements.define('rtl-social-links', RTLSocialLinks);